import creditCardIcon from "../assets/icons/ic_credit_card.png";
import devicesIcon from "../assets/icons/ic_devices.png";
import padlockIcon from "../assets/icons/ic_padlock.png";
import securityIcon from "../assets/icons/ic_security.png";

export const serviceHighlights = [
  {
    id: "pay-per-movie",
    title: "Pay per movie",
    description: "Pay only for the movies you choose.",
    icon: creditCardIcon,
  },
  {
    id: "timed-access",
    title: "Your access, your time",
    description: "Watch at your pace during the access period.",
    icon: securityIcon,
  },
  {
    id: "watch-anywhere",
    title: "Watch anywhere",
    description: "Stream on any device, anytime.",
    icon: devicesIcon,
  },
  {
    id: "safe-secure",
    title: "Safe & secure",
    description: "Your payments and data are always protected.",
    icon: padlockIcon,
  },
];
